export enum LicenseChangeDirection {
  ADDED = "ADDED",
  REMOVED = "REMOVED",
}
